module.exports = __webpack_public_path__ + "img/ics_o_chevron_sort.138edc48.svg";